import React, { forwardRef, useState } from "react";
import { Container, Row, Col, Accordion, Card, useAccordionButton } from "react-bootstrap";
import { arrowDownIcon, arrowUpIcon } from "../../../constants/icons";

function CustomToggle({ children, eventKey, isOpen, onClick }) {
    const decoratedOnClick = useAccordionButton(eventKey, onClick);

    return (
        <div
            className="exam-accordion-header"
            type="button"
            onClick={decoratedOnClick}
        >
            {children}
            {isOpen ? arrowUpIcon : arrowDownIcon}
        </div>
    );
}

const ExamChoicesSection = forwardRef((props, ref) => {
    const [activeKeys, setActiveKeys] = useState(['0']);

    const handleToggle = (eventKey) => {
        if (activeKeys.includes(eventKey)) {
            setActiveKeys(activeKeys.filter(key => key !== eventKey));
        } else {
            setActiveKeys([...activeKeys, eventKey]);
        }
    };

    return (
        <div ref={ref} className="exam-choices-section">
            <Container>
                <Row>
                    <Col lg="6">
                        <div className="exam-choices-holder">
                            <div className="exam-choices-info">
                                <h2>Empowering Students with Flexible Exam Choices</h2>
                                <p>Examally offers flexibility, allowing students to choose topics and display options for past paper questions.</p>
                            </div>

                            <Accordion activeKey={activeKeys} alwaysOpen>
                                <Card className={`mb-2 exam-accordion-card ${activeKeys.includes('0') ? 'active-card' : ''}`}>
                                    <CustomToggle eventKey="0" isOpen={activeKeys.includes('0')} onClick={() => handleToggle('0')}>
                                        <div className="exam-accordion-info">
                                            <span className="circle-count">1</span>
                                            <h4>Select the subject</h4>
                                        </div>
                                    </CustomToggle>
                                    <Accordion.Collapse eventKey="0" className="exam-accordion-content">
                                        <div>Select the Subject and topics you want to study.</div>
                                    </Accordion.Collapse>
                                </Card>

                                <Card className={`mb-2 exam-accordion-card ${activeKeys.includes('1') ? 'active-card' : ''}`}>
                                    <CustomToggle eventKey="1" isOpen={activeKeys.includes('1')} onClick={() => handleToggle('1')}>
                                        <div className="exam-accordion-info">
                                            <span className="circle-count">2</span>
                                            <h4>Filter out the content</h4>
                                        </div>
                                    </CustomToggle>

                                    <Accordion.Collapse eventKey="1" className="exam-accordion-content">
                                        <div>Examally is a cutting-edge platform that creates and organizes personalized study materials to enhance your learning for the Leaving Cert exams.</div>
                                    </Accordion.Collapse>
                                </Card>

                                <Card className={`mb-2 exam-accordion-card ${activeKeys.includes('2') ? 'active-card' : ''}`}>
                                    <CustomToggle eventKey="2" isOpen={activeKeys.includes('2')} onClick={() => handleToggle('2')}>
                                        <div className="exam-accordion-info">
                                            <span className="circle-count">3</span>
                                            <h4>Review the choices</h4>
                                        </div>
                                    </CustomToggle>

                                    <Accordion.Collapse eventKey="2" className="exam-accordion-content">
                                        <div>Examally is a platform that personalizes study materials for Leaving Cert exams. To learn more view our tutorials..</div>
                                    </Accordion.Collapse>
                                </Card>
                                <Card className={`mb-2 exam-accordion-card ${activeKeys.includes('3') ? 'active-card' : ''}`}>
                                    <CustomToggle eventKey="3" isOpen={activeKeys.includes('3')} onClick={() => handleToggle('3')}>
                                        <div className="exam-accordion-info">
                                            <span className="circle-count">4</span>
                                            <h4>Generate the exam</h4>
                                        </div>
                                    </CustomToggle>

                                    <Accordion.Collapse eventKey="3" className="exam-accordion-content">
                                        <div>Empowering Students with Flexible Exam Choices</div>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div>
                    </Col>
                    <Col lg="6">
                        <div className="responsive-map-container">
                            <iframe
                                frameborder="0"
                                src="https://www.youtube.com/embed/bBTgcO6CKv0?si=FsttSZFr-T8JGQKS"
                                width="600"
                                height="450"
                                allowfullscreen
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                                title="YouTube video: Solve equations"
                            ></iframe>

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
});

export default ExamChoicesSection;